import * as d3 from 'd3'

export default {
  methods: {
    
    draw_Table() {


      this.canvasGanttChart = this.canvasGantt
      .append('g')
      .attr('transform', `translate(${this.header.x}, ${this.header.y})`)
      .style('font-family', 'roboto').attr('cursor', 'default')

      this.draw_verticalList() // -----> below

      let _y = this.header.height + 21

      this.navigation.forEach((d,i)=> {

        let dataTable = this.canvasGanttChart
        .append('g')
        .attr('transform', `translate(0, ${_y})`)
        .call(this.open_MenuItem, d)

        dataTable
        .append('rect')
        .attr('id', `Rect_${d.idx}`)
        .attr('x', this.header.columns[2].sx).attr('y', -14.5)
        .attr('width', this.header.columns[2].width + this.header.columns[3].width + this.header.columns[4].width + this.timeline.length)
        .attr('height', 22).attr('fill', '#F4F5F5').attr('opacity', 0)

        // PHASE
        if(i>0 && this.navigation[i-1].PHASE == this.navigation[i].PHASE) {
        } else {
          dataTable
          .append('text')
          .attr('class', `Navi_${d.idx}`)
          .attr('x', this.header.columns[0].sx + 5).attr('font-size', 10).attr('fill', '#333')
          .text(d.PHASE)
        }
        
        // GROUP
        if(i>0 && this.navigation[i-1].PHASE == this.navigation[i].PHASE && this.navigation[i-1].GROUP == this.navigation[i].GROUP) {
        } else {
          dataTable
          .append('text')
          .attr('class', `Navi_${d.idx}`)
          .attr('x', this.header.columns[1].sx + 5).attr('font-size', 10).attr('fill', '#333')
          .text(d.GROUP)
        }

        // ITEM
        dataTable
        .append('text')
        .attr('class', `Navi_${d.idx}`)
        .attr('x', this.header.columns[2].sx + 5).attr('font-size', 10).attr('fill', '#333')
        .text(d.ITEM)

        // REV ***************************
        dataTable
        .append('text')
        .attr('class', `Navi_${d.idx}`)
        .attr('x', this.header.columns[3].mx).attr('font-size', 10).attr('fill', '#333').attr('text-anchor', 'middle')
        .text(d.rev)

        // STATUS ************************
        dataTable
        .append('text')
        // .attr('class', `Navi_${d.idx}`)
        .attr('x', this.header.columns[4].mx).attr('font-size', 9).attr('fill', d.tColor).attr('text-anchor', 'middle')
        .text(d.status == 'Planned' ? '' : d.status)

        // Horizental Line
        if(i<this.navigation.length-1) {
          if(this.navigation[i].PHASE !== this.navigation[i+1].PHASE) {
            dataTable
            .append('line')
            .attr('x1', this.header.columns[0].sx).attr('y1', 9).attr('x2', this.header.columns[0].ex).attr('y2', 9)
            .attr('stroke', '#E0E0DF').attr('stroke-width', .5)
          }

          if(this.navigation[i].PHASE !== this.navigation[i+1].PHASE || this.navigation[i].GROUP !== this.navigation[i+1].GROUP) {
            dataTable
            .append('line')
            .attr('x1', this.header.columns[1].sx).attr('y1', 9).attr('x2', this.header.columns[1].ex).attr('y2', 9)
            .attr('stroke', '#E0E0DF').attr('stroke-width', .5)
          }
          dataTable
          .append('line')
          .attr('x1', this.header.columns[2].sx).attr('y1', 9).attr('x2', this.header.length).attr('y2', 9)
          .attr('stroke', '#E0E0DF').attr('stroke-width', .5)
        }

        this.GanttChart(dataTable, d, _y)
        _y += 25

      })

    },


    draw_verticalList() {
      this.header.columns.forEach(d=> {
        this.canvasGanttChart
        .append('line')
        .attr('x1', d.ex).attr('y1', 40)
        .attr('x2', d.ex).attr('y2', this.tblHeight)
        .attr('stroke', '#bcbcbc').attr('stroke-width', .3)
      })

      this.canvasGanttChart
      .append('g')
      .selectAll('line')
      .data(this.timeline.month)
      .enter()
      .append('line')
      .attr('x1', d => this.timeline.scale(d.eDate) + this.header.width).attr('y1', 40)
      .attr('x2', d => this.timeline.scale(d.eDate) + this.header.width).attr('y2', this.tblHeight)
      .attr('stroke', '#f5f5f5').attr('oapcity', .1)
      .attr('stroke-width', 1)

      this.canvasGanttChart
      .append('line')
      .attr('x1', 0).attr('y1', this.tblHeight+1)
      .attr('x2', this.header.length).attr('y2', this.tblHeight+1)
      .attr('stroke', '#757575').attr('stroke-width', .3)
    },

  }
}
